import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";
import { format } from "date-fns";
import placeholder from "../../../../static/img/img_placeholder.png";
import { setSelectedScoutingFeature } from "../../../../actions/resultMap";

export const ScoutingFeature = ({ scoutingFeature }) => {
  const selectedScoutingFeature = useSelector(
    ({ resultMap }) => resultMap.selectedScoutingFeature
  );
  const dispatch = useDispatch();

  return (
    <div
      className={`scouting-feature clickable ${
        selectedScoutingFeature?.id === scoutingFeature.id ? "active" : ""
      }`}
      onClick={() => {
        dispatch(setSelectedScoutingFeature(scoutingFeature));
      }}
    >
      <img src={scoutingFeature.thumbnail ?? placeholder} alt="scouting" />
      <div className="p-1 d-flex flex-column">
        <span className="font-weight-bold">
          {format(scoutingFeature.datetime, "yyyy-MM-dd")}
        </span>
        <span>{format(scoutingFeature.datetime, "hh:mm:ss")}</span>
      </div>
    </div>
  );
};

ScoutingFeature.propTypes = {
  scoutingFeature: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail: PropTypes.string,
    datetime: PropTypes.string.isRequired,
  }).isRequired,
};
